export const PRICES = [
  {
    key: '1',
    title: 'Dla firmy',
    description:
      'Wersja przeznaczona do sporządzenia\ne-sprawozdania finansowego dla jednego podmiotu gospodarczego',
    price: '910,-',
  },
  {
    key: '2',
    title: 'Dla biura rachunkowego',
    description:
      'Wersja przeznaczona do sporządzenia\ne-sprawozdań finansowych dla wielu podmiotów gospodarczych',
    price: '1 490,-',
  },
]
